import { useCallback, useMemo } from 'react'

import {
  formatUtcOffsetLabel,
  getBrowserUtcOffsetHours,
  useTimeFormatter
} from './_shared/useTimeFormatter'

export function useTopSQLTooltipTimeHeaderFormatter() {
  const tooltipTimeFormatter = useTimeFormatter('YYYY-MM-DD HH:mm:ss')
  const timezoneLabel = useMemo(
    () => `UTC ${formatUtcOffsetLabel(getBrowserUtcOffsetHours())}`,
    []
  )

  return useCallback(
    (timestamp: number) =>
      `${tooltipTimeFormatter(timestamp)} (${timezoneLabel})`,
    [timezoneLabel, tooltipTimeFormatter]
  )
}
